import { render, staticRenderFns } from "./CcNodeConfig.vue?vue&type=template&id=96b8c218&scoped=true"
import script from "./CcNodeConfig.vue?vue&type=script&lang=js"
export * from "./CcNodeConfig.vue?vue&type=script&lang=js"
import style0 from "./CcNodeConfig.vue?vue&type=style&index=0&id=96b8c218&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96b8c218",
  null
  
)

export default component.exports